<template>
  <div class="container flex flex-column">
    <div class="box">
      <div class="userInfo flexCenter " @click="toRegister">
        <div class="avatarBox">
          <img :src="avatar" v-if="avatar">
          <img src="@/assets/images/avatar.png" v-else>
        </div>
        <div class="ml10" v-if="username">
          <p>{{username}}</p>
          <p class="mt10">{{tel}}</p>
        </div>
        <!-- 没有提示去注册 -->
        <div class="ml10" v-if="!username">
          <p class="font-16">点击去注册</p>
        </div>
      </div>
      <div class="reportBox clearfix bg-fff mb8">
        <div class="title relative line-b-E5E5E5 font-16 bold" @click="goMoreRrport()">检查报告<img src="@/assets/images/arrow_right.png" alt="" class="more absolute"></div>
        <div class="reportList">
          <div class="listItem line-b-E5E5E5 bg-fff" v-for="(item,index) in reportList" :key="index" @click="reportDetail(item.auditId)" v-if="index<3">
            <p>审核日期：{{item.optTime}}</p>
            <p class="mt10" v-if="item.positiveNum">异常指标：<span class="color-red">{{item.positiveNum}} &nbsp;</span>个</p>
          </div>
        </div>
        <van-empty v-if="!reportList || reportList.length == 0" class="custom-image" :image="emptyImg" description="没有数据" />
      </div>
      <div class="resultBox bg-fff clearfix mb10">
        <div class="title line-b-E5E5E5 relative font-16 bold" @click="goMoreResult()">检查结果<img src="@/assets/images/arrow_right.png" alt="" class="more absolute"></div>
        <div class="resultlist" v-for="(item,index) in resultlist" :key="index" @click="resultTrend(item.elementId,item.elementName,item.resultType)">
          <div class="resultItem flex" :class="index != resultlist.length-1?'line-b-E5E5E5':''" v-if="index < 3">
            <ul class="flex1">
              <li class="flex"><span class="resultItemTitle">项目名</span>：{{item.elementName}}</li>
              <li class="flex mt10">
                <span class="resultItemTitle">结果</span>：
                <!-- resultType 为1是数值 2是文本 3是文件 -->
                <p class="flexCenter" v-if="item.resultType == 1">
                  <span>{{item.resultContent}}</span>
                  <span class="color-red" v-if="item.positiveSymbol.indexOf('H') > -1">&nbsp;↑</span>
                  <span class="color-red" v-if="item.positiveSymbol.indexOf('L') > -1">&nbsp;↓</span>
                </p>
                <p class="flexCenter" v-if="item.resultType == 2">
                  <span>{{item.resultContent}}</span>
                  <span class="color-red" v-if="item.positiveSymbol.indexOf('A') > -1">&nbsp;!</span>
                </p>
                <p class="flexCenter" v-if="item.resultType == 3">
                  <span @click="fileDownload(item2.resultContent)">查看</span>
                </p>
              </li>
              <li class="flex mt10"><span class="resultItemTitle">单位</span>：{{item.unit}}</li>
              <li class="flex mt10" v-if="item.positiveValue"><span class="resultItemTitle">异常描述</span>:{{item.positiveValue}}</li>
              <li class="flex mt10"><span class="resultItemTitle">参考范围</span>：{{item.referenceShow}}</li>
              <li class="flex mt10"><span class="resultItemTitle">检查日期</span>：{{item.examTime}}</li>
            </ul>
            <span v-if="item.resultType == 1">查看历史趋势</span>
          </div>
        </div>
        <van-empty v-if="!resultlist || resultlist.length == 0" class="custom-image" :image="emptyImg" description="没有关注数据" />
      </div>
    </div>
    <!-- <div class="textCenter footerBtn color-fff">健康管家</div> -->
  </div>
</template>
<script>
  import { Button ,Empty,ImagePreview ,Toast } from "vant";
export default {
  name: 'Index',
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [ImagePreview.name]: ImagePreview
  },
  data() {
    return {
      emptyImg:require('@/assets/images/empty.png'),
      username:'',
      tel:'',
      avatar:'',
      reportList:[],
      resultlist:[],
    }
  },
  watch: {

  },
  created() {
    if (!sessionStorage.getItem('logNum')) {
      this.getAppid.outsideModel.getInit();
    };
    this.getUserInfo();
    this.getReportList();
    this.getResultList();
    // this.getOppenId().then(res=>{
    //   if(res.code == 200){
    //     this.getUserInfo();
    //     this.getReportList();
    //     this.getResultList();
    //   };
    // }).catch(err=>{

    // });
  },
  methods: {
    getOppenId(){
      let self = this;
      return new Promise(function(resolve,reject){
        $.ajax({
          url: self.GLOBAL.url+'/common/generateOpenId',
          type: 'get',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          data: {

          },
          success: (res) => {
            resolve(res)
          },
          error: (e) => {
            reject(e)
            console.log(e);
          }
        })
      })
    },
    getUserInfo() {
      $.ajax({
        url: this.GLOBAL.url + '/openIdInfo/getByInfo',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {

        },
        success: (res) => {
          if (res.code == 200) {
            if(res.data){
              this.username = res.data.name;
              this.tel = res.data.mobile;
              this.avatar = res.data.reserved1;
            }
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    /*获取报告列表*/
    getReportList(){
      $.ajax({
        url: this.GLOBAL.url + '/wx/listReport',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          pageNum:1,
          pageSize:3
        },
        success: (res) => {
          if (res.code == 200) {
            this.reportList = res.data.list;
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    /*获取检查结果列表*/
    getResultList(){
      $.ajax({
        url: this.GLOBAL.url + '/wx/latestResult',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          pageNum:1,
          pageSize:3,
          queryTop:1,//0包含首页显示与未显示 1首页显示的
        },
        success: (res) => {
          if (res.code == 200) {
            this.resultlist = res.data.list;
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    /*图片预览*/
    getImgPreview(index){
      /*http://IP:12500/oss/getAccessUrl?bucketName=jk-test1&objectName=ecg-png-110108198910263626-20210309162553.png*/
      ImagePreview({
          images: this.images, // 预览图片的那个数组
          showIndex:true,//是否显示页码
          loop:false,//是否开启循环
          startPosition:index, // 指明预览第几张图
      })
    },
    /*注册or显示用户信息*/
    toRegister(){
      if(this.username){
        this.$router.push({name:'UserInfo'});
      }else{
        this.$router.push({path:'/register',query:{avatar:this.avatar}});
      };
    },
    /*查看文件*/
    fileDownload(filename){
      if(filename){
       $.ajax({
          url: this.GLOBAL.aliyunOssUrl + '/getAccessUrl',
          type: 'get',
          xhrFields: {
            withCredentials: true
          },
          data: {
           bucketName:'jk-test1',
           objectName:filename
          },
          crossDomain: true,
          success: (res) => {
            if (res.code == 200) {
              window.top.location.href= res.data.url;
            } else {
              this.$toast(res.msg)
            };
          },
          error: (e) => {
            console.log(e);
          }
        })
      }else{
        Toast('文件名不可为空！');
      }
    },
    // 查看报告详情
    reportDetail(id){
      if(this.username && this.tel){
        this.$router.push({name:'ReportDetail',query:{id:id}});
      }else{
        this.$router.push({path:'/register'});
      };
    },
    // 报告列表
    goMoreRrport(){
      if(this.username && this.tel){
        this.$router.push({name:'ReportList'});
      }else{
        this.$router.push({path:'/register'});
      };
    },
    // 结果历史趋势
    resultTrend(id,name,type){
      if(this.username && this.tel){
        if(type == 1){
          this.$router.push({name:'ResultTrend',query:{id:id,name:name}})
        }
      }else{
        this.$router.push({path:'/register'});
      };
    },
    goMoreResult(){
      if(this.username && this.tel){
        this.$router.push({name:'ResultList'});
      }else{
        this.$router.push({path:'/register'});
      };
    }
  },
  computed: {

  },
}
</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
}

.box {
  flex: 1;
  width: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  height: auto;
}

.userInfo {
  padding: 0.8rem 0.266667rem;
}

.avatarBox {
  display: table-cell;
  width: 1.6rem;
  height: 1.6rem;
  vertical-align: middle;
  border-radius: 1.066667rem;
  overflow: hidden;
}

.avatarBox img {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.reportBox,
.resultBox {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  border: 0.026667rem solid #E5E5E5;
  border-radius: 0.266667rem;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.title {
  padding: 0.4rem 0.266667rem;
}

.more {
  right: 0.266667rem;
  width: 0.533333rem;
  height: 0.533333rem;
}

.badge {
  right: 0.8rem;
  width: 0.533333rem;
  height: 0.533333rem;
  line-height: 0.533333rem;
  background-color: #ee0a24;
  border-radius: 0.8rem;
}

.listItem {
  padding: 0.266667rem 0.266667rem;
}

.reportDetails {
  padding: 0.266667rem 0.533333rem;
  border: 0.026667rem solid #E5E5E5;
  border-radius: 0.133333rem;
}

.arrow_right {
  display: inline-block;
  width: 0.533333rem;
  height: 0.533333rem;
}

.resultItem {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  padding: 0.266667rem 0;
  line-height: 0.533333rem;
}

.resultItemTitle {
  text-align-last: justify;
  -moz-text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
  display: block;
  flex: 0 0 2.133333rem;
}

.footerBtn {
  padding: 0.266667rem 0;
  background-color: rgb(25, 137, 250);
}

/deep/ .custom-image .van-empty__image {
  width: 2.4rem;
  height: 2.4rem;
}
</style>